"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LoadMoreButton = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _LoadMoreProgress = require("./LoadMoreProgress");

var _excluded = ["loaded", "total", "onLoadMore", "loadMoreMessage", "noMoreMessage", "className"];

var LoadMoreButton = function LoadMoreButton(props) {
  var loaded = props.loaded,
      total = props.total,
      onLoadMore = props.onLoadMore,
      loadMoreMessage = props.loadMoreMessage,
      noMoreMessage = props.noMoreMessage,
      className = props.className,
      remainingProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var wrapperClassNames = (0, _classnames.default)('LoadMoreButton', 'align-items-center', 'display-flex', 'justify-content-center', 'margin-top-25', 'margin-bottom-25', 'non-printable', className);
  var hasMoreToLoad = loaded > 0 && total > 0 && loaded !== total;
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, remainingProps, {
    className: wrapperClassNames
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: 'min-width-150'
  }, /*#__PURE__*/_react.default.createElement(_LoadMoreProgress.LoadMoreProgress, {
    loaded: loaded,
    total: total
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: 'display-flex justify-content-center'
  }, hasMoreToLoad && /*#__PURE__*/_react.default.createElement("button", {
    className: 'btn btn-link padding-right-20 margin-top--5',
    type: 'button',
    onClick: onLoadMore
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: 'rioglyph rioglyph-arrow-down'
  }), loadMoreMessage), !hasMoreToLoad && /*#__PURE__*/_react.default.createElement("span", {
    className: 'padding-top-4 padding-bottom-10'
  }, noMoreMessage))));
};

exports.LoadMoreButton = LoadMoreButton;
LoadMoreButton.defaultProps = {
  onLoadMore: function onLoadMore() {},
  className: '',
  loadMoreMessage: '',
  noMoreMessage: ''
};
LoadMoreButton.propTypes = {
  loaded: _propTypes.default.number,
  total: _propTypes.default.number,
  loadMoreMessage: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  noMoreMessage: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  onLoadMore: _propTypes.default.func.isRequired,
  className: _propTypes.default.string
};
var _default = LoadMoreButton;
exports.default = _default;